export enum OperationFonction {
  Actif = 1,
  Visualisation = 2,
  Edition = 4,
  Suppression = 8,
  Export = 16,
  Creation = 32,
}
